import type {
  ApiResponseGetCategoriesResponse,
  ApiResponseShopDetailDto, ApiResponseProductsEntityList
} from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";

export class ShopApiService {
  async getShopHome(): Promise<ApiResponseShopDetailDto> {
    const response = await httpClient.get<ApiResponseShopDetailDto>(
      NEW_API_ENDPOINTS.shopController.GET.shopHome,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "쇼핑몰 정보를 가져오지 못했습니다.",
      );
    }

    return response.data;
  }

  async getShopHomeById(shopId: number): Promise<ApiResponseShopDetailDto> {
    const response = await httpClient.get<ApiResponseShopDetailDto>(
      NEW_API_ENDPOINTS.shopController.GET.shopHome,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "쇼핑몰 정보를 가져오지 못했습니다.",
      );
    }

    return response.data;
  }
}

export const shopApiService = new ShopApiService();